import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '../../../utilities/appFetch';
import alarmSequenceRoutes from '../../../components/alarmSequence/alarmSequenceRoutes';

const update = createAsyncThunk(
  'thunk/alarmSequence/delete',
  async (arg, thunkAPI) => {
    const response = await apiFetch(alarmSequenceRoutes.api.generate.delete(arg?.id), {
      method: 'DELETE',
    });
    if (!response?.success) {
      return thunkAPI.rejectWithValue(response);
    }
    return response.result;
  },
);

export default update;
